import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu } from "../../../../api";
import { menuFallback } from "../../../../utils/menuFallback";

const menuController = new Menu();

export function Nav({ navMobile, setNavMobile }) {
  const [menuData, setMenuData] = useState([]);
  const [activeItem, setActiveItem] = useState("");
  const location = useLocation();

  useEffect(() => {
    setActiveItem(location.pathname);
  }, [location]);

  useEffect(() => {
    (async () => {
      try {
        const response = await menuController.getMenu(true);
        setMenuData(response);
      } catch {
        setMenuData(menuFallback);
      }
    })();
  }, []);

  const handleNavClick = () => {
    if (setNavMobile) setNavMobile(false);
  };

  return (
    <nav className="lg:flex lg:items-center">
      <ul className="flex flex-col lg:flex-row lg:items-center gap-1 lg:gap-1">
        {menuData.map((item) => {
          const isActive = activeItem === item.url;
          return (
            <li key={item.id || item.url}>
              <Link
                className={`
                  relative px-4 py-2 rounded-lg text-sm font-semibold transition-all duration-200 block
                  ${isActive
                    ? "text-white bg-white/15"
                    : "text-white/70 hover:text-white hover:bg-white/10"
                  }
                `}
                to={item.url}
                onClick={handleNavClick}
              >
                {item.title}
                {isActive && (
                  <span className="absolute bottom-0 left-1/2 -translate-x-1/2 w-4 h-0.5 bg-[#C81416] rounded-full" />
                )}
              </Link>
            </li>
          );
        })}
      </ul>
    </nav>
  );
}
